import { useT } from '@/i18n/runtime';
import { track } from '@/flow/instrument';
import { useHelp } from './HelpContext';

/**
 * The persistent help control (SPEC_CAPTURE_UX_R2 §7.1, P9): 48×48 dp, labelled "Help", on EVERY screen — rendered by
 * the Shell. Placed top-right rather than the spec's bottom-right because on the capture screens the bottom-right is
 * the bar's Skip slot (round 1's one-gesture bar); the acceptance ("one tap from any screen") holds either way.
 */
export function HelpButton(): JSX.Element {
  const { t } = useT();
  const { show, open, step } = useHelp();
  // §10 "Help button → help-open rate per step": a step with an outlier rate is a design defect, not a training gap.
  const onOpen = (): void => {
    track('help.open', { screen: step?.screen ?? 'other', ...(step?.shot?.promptKey ? { promptKey: step.shot.promptKey } : {}) });
    show('step');
  };
  return (
    <button type="button" className="sv-help-btn" onClick={onOpen} aria-label={t('sv.help.button')} aria-expanded={open} data-testid="help-button">
      <span aria-hidden="true">?</span>
      <span className="sv-help-btn-label">{t('sv.help.button')}</span>
    </button>
  );
}
